import { STOCK_TYPES } from "../constants"
import { type ProductConditions } from "../types"

export const createColumns = (
  productDetails: ProductConditions
): { content?: string | string[] | boolean | null; testId: string; label?: string }[] => [
  {
    content: productDetails.warehouseAreas?.map((w) => `${w.externalSystemId} ${w.location?.description}`),
    testId: "assigned-warehouses",
    label: "",
  },
  { content: STOCK_TYPES.find((type) => type.value === productDetails.stockType)?.label || "", testId: "stock-type" },
  { content: productDetails.excludedFromCombinedPricing, testId: "combined-pricing", label: "Excluded" },
  { content: productDetails.isOnAllocation, testId: "allocation", label: "On Allocation" },
]

export const checkHasProductConditions = (productConditions?: ProductConditions | null): boolean => {
  if (!productConditions) return false

  return (
    !!productConditions.stockType ||
    !!productConditions.excludedFromCombinedPricing ||
    !!productConditions.isOnAllocation ||
    (productConditions.warehouseAreas?.length ?? 0) > 0
  )
}
